import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileUrlQueryAtom = createMutationAtomFactory(
  'trade.fileUrl',
  (params: { fileIds: string[] }) => ({
    filesGenerateFileAccessURL: {
      __args: {
        fileIds: params.fileIds,
      },
      results: {
        fileId: true,
        url: true,
      },
    },
  }),
  {
    select: ({ filesGenerateFileAccessURL }) =>
      filesGenerateFileAccessURL.results ?? [],
    showLoadingOverlay: false,
  },
);
